<template lang="pug">
.card
    md-card(md-with-hover )
        md-card-media-cover(md-text-scrim @click.native="toggle")
            md-card-media(md-ratio="16:9" )
                img(:src="img" style="display:block;margin:auto")
            md-card-area
                md-card-header
                    .md-title {{title}}
                    .md-subhead {{subtitle | replace($t('label.other'), '') | replace('_'|'')}}
        md-card-actions
          md-menu(md-size="big" md-direction="bottom-end" :md-active.sync="toggleCard")
              md-menu-content
                  md-menu-item(v-for="(item, index) in list" :key="index" @click.prevent="pick(index)") {{item.name | replace($t('label.other'), '') | replace('_','')}}

          md-button.md-flat.md-accent(id="select" ref="select" @click.prevent="toggle" ) {{$t('select.breed')}}
          span(style="flex:1;")
          md-button.md-raised.md-primary(:disabled="idx===-1" @click.prevent="selectType(id)") {{$t('label.select')}}
</template>
<script>
export default {
  name: 'BreedCard',
  props: ['id', 'title', 'img', 'list', 'select', 'active'],
  data () {
    return {
      idx: -1,
      toggleCard: false
    }
  },
  watch: {
    active () {
      if (this.active !== this.id) {
        this.idx = -1
      }
    }
  },
  computed: {
    subtitle () {
      if (this.idx === -1) {
        return ''
      }
      return this.list[this.idx].name || ''
    }
  },
  created () {
    this.idx = -1
  },
  methods: {
    selectType (id) {
      this.toggleCard = false
      this.$emit('index', { type: id, index: this.list[this.idx].breedID })
    },
    pick (index) {
      this.idx = index
      this.$emit('sel', this.id)
    },
    toggle () {
      this.toggleCard = !this.toggleCard
    }
  }
}
</script>
<style scoped>
.md-card {
    margin: 0px;
}
button#select:hover {
  border-width: 1px;
  border-color: #012c58;
  border-style: solid;
}
</style>



// WEBPACK FOOTER //
// src/components/CardSelect.vue